import { Model } from 'pinia-orm';

export default class Member extends Model {

    static get entity () {
        return 'members';
    }

    static fields () {
        return {
            id: this.uid(),
            first_name: this.attr('JON'),
            last_name: this.attr(''),
            email: this.attr(''),
            social_facebook: this.attr(''),
            social_instagram: this.attr(''),
            social_linkedin: this.attr(''),
            social_twitter: this.attr(''),
            title: this.attr({}),
            description: this.attr({}),
            image_url: this.attr(''),
            translated_video_url: this.attr({}),
            video_url: this.attr(null),
            pivot: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null)
        }
    }
}
